import React from "react";

const InterviewList = (props) => (
  <section id="interviews">
    <div className="section_hexagon" />
    <div className="section_title">
      <p>INTERVIEWS</p>
      <h2>LYZONで働く社員からのメッセージ</h2>
    </div>
    <div className="section_contents">
      <div className="interview_list">
        <ul className="interview_slick">
          <li>
            <a data-id="shindo">
              <div className="visual"><img src="images/interviews/shindo_main.webp" alt="" /></div>
              <div className="title">新しいことに挑戦できる環境がある</div>
              <div className="job">常務取締役・エンジニア・マネージャー</div>
              <div className="box">
                <div className="day">2012年入社</div>
                <div className="career">中途入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="takada">
              <div className="visual"><img src="images/interviews/takada_main.webp" alt="" /></div>
              <div className="title">仕事と家庭を両立しながら活躍できる場がある</div>
              <div className="job">経営企画室・チーフ</div>
              <div className="box">
                <div className="day">2012年入社</div>
                <div className="career">中途入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="maehara">
              <div className="visual"><img src="images/interviews/maehara_main.webp" alt="" /></div>
              <div className="title">理想的な制作環境と高度な技術力が強み</div>
              <div className="job">ディレクター・マネージャー</div>
              <div className="box">
                <div className="day">2017年入社</div>
                <div className="career">中途入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="yamaguchi">
              <div className="visual"><img src="images/interviews/yamaguchi_main.webp" alt="" /></div>
              <div className="title">自分のノウハウを後輩へ伝授するのが役目</div>
              <div className="job">エンジニア</div>
              <div className="box">
                <div className="day">2021年入社</div>
                <div className="career">中途入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="kobayashi">
              <div className="visual"><img src="images/interviews/kobayashi_main.webp" alt="" /></div>
              <div className="title">自分の意見が言える会社という色を大事にしていきたい</div>
              <div className="job">ディレクター・マネージャー</div>
              <div className="box">
                <div className="day">2014年入社</div>
                <div className="career">新卒入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="uemura">
              <div className="visual"><img src="images/interviews/uemura_main.webp" alt="" /></div>
              <div className="title">当たり前のことが大切にされている会社</div>
              <div className="job">ディレクター・チーフ</div>
              <div className="box">
                <div className="day">2018年入社</div>
                <div className="career">中途入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="kim">
              <div className="visual"><img src="images/interviews/kim_main.webp" alt="" /></div>
              <div className="title">マルチに活躍できるデザイナーとしてスキルアップできる</div>
              <div className="job">デザイナー・チーフ</div>
              <div className="box">
                <div className="day">2017年入社</div>
                <div className="career">新卒入社</div>
              </div>
            </a>
          </li>
          <li>
            <a data-id="tanuma">
              <div className="visual"><img src="images/interviews/tanuma_main.webp" alt="" /></div>
              <div className="title">お客様が抱えるさまざまな課題を解決できる提案を</div>
              <div className="job">取締役・企画提案営業・マネージャー</div>
              <div className="box">
                <div className="day">2008年入社</div>
                <div className="career">新卒入社</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
)

export default class Interview extends React.PureComponent {

  componentDidMount() {
    setTimeout(() => {
      let list =  document.querySelectorAll('#interviews .section_contents .interview_list ul li a')

      for (const item of list) {
        item.addEventListener('click', this.props.toInterview, false)
      }
    }, 1000)
  }

  render() {
    return <InterviewList />
  }
}


// WEBPACK FOOTER //
// ./src/Home/Interviews.js